import { toast } from 'sonner';
import { Button } from '@/components/ui/button';

// FUENTE UNICA de las URLs de webhook por proveedor que el admin debe pegar en el
// panel del proveedor. La consumen: (1) el Wizard al conectar un numero nuevo y
// (2) el DETALLE de la cuenta (numeros ya creados). Endpoints backend estables:
//   /api/webhook/gupshup                (Gupshup)
//   /api/webhook/twilio  + /twilio/status (Twilio necesita LOS DOS)
// No dupliques estos datos en otro archivo: importa WABA_WEBHOOKS desde aqui.
export const WABA_WEBHOOKS = {
  gupshup: [
    { label: 'Callback URL (mensajes)', path: '/api/webhook/gupshup', where: 'En Gupshup: tu App > Settings > campo Callback URL.' },
  ],
  twilio: [
    { label: '1. Cuando llega un mensaje', path: '/api/webhook/twilio', where: 'Twilio > tu Sender de WhatsApp > campo When a message comes in.' },
    { label: '2. Estado de entrega', path: '/api/webhook/twilio/status', where: 'Twilio > mismo Sender > campo Status callback URL.' },
  ],
};

// Muestra la(s) URL(s) de webhook del proveedor con boton copiar y donde pegarlas.
export function WabaWebhookBox({ provider, label }) {
  const hooks = WABA_WEBHOOKS[provider];
  if (!hooks || !hooks.length) return null;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const copy = (url) => { try { navigator.clipboard.writeText(url); toast.success('URL copiada'); } catch (e) {} };
  return (
    <div className="mt-3 space-y-2 rounded-lg border border-amber-500/30 bg-amber-500/5 p-3" data-testid="waba-detail-webhook-box">
      <p className="text-xs font-semibold text-amber-300">Pega esta URL en el panel de {label || provider}</p>
      <p className="text-[11px] text-amber-200/70">Sin esto, {label || provider} no le entrega los mensajes a tu sistema.</p>
      {hooks.map((w, i) => {
        const url = `${origin}${w.path}`;
        return (
          <div key={i} className="rounded-md bg-black/30 border border-white/10 p-2.5">
            <p className="text-[11px] text-white font-medium">{w.label}</p>
            <p className="text-[10px] text-gray-400 mb-1.5">{w.where}</p>
            <div className="flex items-center gap-2">
              <code className="flex-1 text-[11px] text-amber-200 break-all bg-black/40 rounded px-2 py-1.5">{url}</code>
              <Button type="button" size="sm" variant="outline" className="shrink-0 text-xs border-white/10" onClick={() => copy(url)} data-testid={`waba-detail-webhook-copy-${i}`}>Copiar</Button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
